// extracted by mini-css-extract-plugin
export var cdTiny = "video-module--cd-tiny--b3fa5";
export var cdVideo = "video-module--cd-video--8a5d9";
export var cdVideoThumb = "video-module--cd-video-thumb--28d88";